export const withSafeFetch = async (
  fetcher,
  fallbackMessage = 'Server error'
) => {
  try {
    return await fetcher();
  } catch (error) {
    console.error('Fetch failed:', error);
    throw createError({
      statusCode: 500,
      statusMessage: fallbackMessage,
    });
  }
};

export default defineNuxtPlugin(() => {
  return {
    provide: {
      safeFetch: withSafeFetch
    }
  };
});
